import React from 'react'

const TextAreaField = ({
    name,
    label,
    placeholder,
    value,
    onChange,
    onBlur,
    error,
    touched,
    defaultValue,
    rows,
    maxLength,
}: {
    name: string
    label?: string
    placeholder?: string
    value: string
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
    onBlur: (e: React.FocusEvent<HTMLTextAreaElement>) => void
    error: string | undefined
    touched: boolean | undefined
    defaultValue?: string
    rows: number
    maxLength?: number
}) => {
    const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (maxLength === undefined) return
        if (e?.target?.value?.length <= maxLength) {
            onChange(e)
        }
    }

    const handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
        if (maxLength === undefined) return
        const pasteText = e.clipboardData.getData('text')
        const newText = value + pasteText
        if (newText?.length > maxLength) {
            e.preventDefault()
        }
    }
    return (
        <div className="form mb-3">
            {label && <label>{label}</label>}
            <textarea
                className="form-control mt-2"
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={handleTextChange}
                onPaste={handlePaste}
                onBlur={onBlur}
                defaultValue={defaultValue}
                rows={rows}
            />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                }}
            >
                {error && touched ? (
                    <div style={{ color: 'red' }}>{error}</div>
                ) : (
                    <div></div>
                )}
                {maxLength && (
                    <span>
                        {maxLength - value?.length}/{maxLength}
                    </span>
                )}
            </div>
        </div>
    )
}

export default TextAreaField
